import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IdesignArchRoutingModule } from './idesign-arch-routing.module';
import { IdesignArchComponent, DashboardAssignments, GmatformComponent } from './idesign-arch.component';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { ComponentsModule } from '../components/components.module';
import { ChildComponentsModule } from '../components/child-components.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { SwiperModule } from 'swiper/angular';
import { CommonChildComponentsModule } from '../components/common-components.module'

@NgModule({
  declarations: [
    IdesignArchComponent,
    DashboardAssignments,
    GmatformComponent,
  ],
  imports: [
    CommonModule,
    IdesignArchRoutingModule,
    ChildComponentsModule,
    CommonChildComponentsModule,
ComponentsModule,
    MatBottomSheetModule,MatDialogModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    SwiperModule
  ]
})
export class IdesignArchModule { }
